import type {
  Maybe,
  TermsAndConditions,
  ThresholdType
} from "@shared/graphql.types";

export type ThresholdProgressResult = {
  showProgress: boolean;
  progressBanner?: {
    copy: string;
    termsAndConditions: TermsAndConditions;
  };
  percentProgress?: string;
  type?: string;
};

export const getThresholds = ({
  items
}: {
  items: Maybe<ThresholdType>[] | undefined;
}): ThresholdProgressResult[] | [] => {
  if (!items || items.length === 0) {
    return [];
  }

  return items?.map((threshold) => {
    const showProgress = !!threshold?.progressBanner?.showBanner;

    return {
      showProgress,
      progressBanner: showProgress
        ? {
            copy: threshold.progressBanner.copy ?? "",
            termsAndConditions: threshold.progressBanner.termsAndConditions ?? {
              links: [],
              template: ""
            }
          }
        : undefined,
      percentProgress: showProgress ? threshold.percentProgress : undefined,
      type: threshold?.type ?? undefined
    };
  });
};
